import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

interface StylesProps {
  mapDetailsTop: string;
  mapDetailsLeft: string;
  clickedState: boolean;
}

export const useStyles = makeStyles({
  detailsBox: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    opacity: '100%',
    padding: '2px 6px',
    position: 'fixed',
    transform: 'translateX(10px) translateY(calc(-100% - 30px))',
    zIndex: 100,
    borderRadius: '4px',
    backgroundColor: colors.white,
    top: ({ mapDetailsTop }: StylesProps) => mapDetailsTop,
    left: ({ mapDetailsLeft }: StylesProps) => mapDetailsLeft,
  },
  detailsBoxName: {
    fontWeight: 500,
    fontSize: '10px',
    textAlign: 'center',
    color: colors.gray.l30,
    marginTop: '-2px',
  },
  detailsBoxCount: {
    fontWeight: 600,
    fontSize: '20px',
    textAlign: 'center',
    color: colors.gray.l15,
    marginTop: '-2px',
  },
  mapCard: {
    position: 'relative',
    marginTop: '24px',
  },
  mapArea: {
    backgroundColor: colors.gray.l98,
    border: '1px solid #555555',
    borderRadius: '4px',
    display: 'block',
    overflow: 'auto',
    maxHeight: '580px',
    '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar for Chrome, Safari and Opera
    '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
    scrollbarWidth: 'none', // Hide scrollbar for Firefox
  },
  stateArea: {
    fill: colors.gray.l45,
    opacity: 1,
    stroke: colors.gray.l98,
    strokeWidth: 1,
    transition: 'fill .4s ease',
    '&:hover': {
      fill: colors.orange.l60,
      cursor: ({ clickedState }: StylesProps) => {
        return clickedState ? 'wait' : 'pointer';
      },
    },
  },
  zoom: {
    position: 'absolute',
    right: '24px',
    bottom: '24px',
    width: '39px',
    height: '86px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: colors.white,
    boxShadow: '0px 1px 4px rgba(40, 40, 40, 0.1)',
    borderRadius: '6px',
    zIndex: 1,
  },
  zoomIcon: {
    height: '50%',
    width: '100%',
    color: colors.gray.l10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 0,
    minWidth: 0,
    fontSize: '44px',
    fontWeight: 400,
    paddingTop: '2px',
    '&:hover': {
      cursor: 'pointer',
      color: colors.black,
    },
  },
  zoomInIcon: {
    borderBottom: `1px solid ${colors.gray.l94}`,
  },
});
